import React, { Component } from 'react'
import Vote from './Vote'

import { withTranslation } from 'react-i18next';

import ConfirmationPopup from '../components/ConfirmationPopup'
import ApplicationIcon from './ApplicationIcon';

class CustomListComponent extends Component {

    state = {
        template: undefined
    }

    constructor(props) {
        super(props)

        this.onClick = this.onClick.bind(this)
    }

    static getDerivedStateFromProps(props, state) {
        state.template = props.template

        return state
    }


    onClick(event) {
        if (!this.state.showDeleteConfirmation && this.props.onClick) {
            this.props.onClick(this.props.template);
        }
    }

    render() {

        const { t } = this.props;

        let classValue = "list-group-item";

        if (this.props.selected === this.props.template) {
            classValue += " active"
        }

        if (this.props.removehand) {
            classValue += " remove_hand"
        }
        const template = this.state.template

        const apps = template.blocks
            .filter(block => block.application &&  block.application !== "" && block.application !== "simplyflows_schedule" && block.application !== "scheduler" && block.application !== "simplyflowsemail") //TODO: Remove the old ones
            .slice(0,4)
            .map(block => <div className="p-1" onClick={this.onClick} style={{ border: "1px solid #E6E6E6", borderRadius: "5px", margin: "5px"}} key={block.application}> <ApplicationIcon onlyIcon="true" appType={block.application} /></div>)

        /* TODO: Add those later <td className="icons-list-item"><ApplicationIcon onlyIcon="true" appType={template.blocks[0].application} className="icons-list-item" /></td>
                        <td className="icons-list-item"><ApplicationIcon onlyIcon="true" appType={template.blocks[1].application} className="icons-list-item" /></td> */
        if (template.comingsoon) {
            return this.props.isLegacy? (
                <div className="p-4" onClick={this.onClick} style={{ border: "1px solid #E6E6E6", borderRadius: "10px", padding: "40px", margin: "20px", cursor: "default", width: "300px" }} key={this.state.template._id}>
                    <div className="d-flex justify-content-center">{apps}</div>
                    <br />
                    <table className="icons-list"><tbody><tr>
                        <td className="disabled">{template.title}
                            <br />
                            <br />
                            <Vote votes={template.votes} type="template" docId={template._id} /></td>
                    </tr></tbody></table>
                </div>) : (
                <div className="p-4" onClick={this.onClick} style={{ border: "1px solid #E6E6E6", borderRadius: "10px", padding: "40px", cursor: "default", width: "300px", margin: this.props.windowWidth > 993 ? "20px" : "auto" }} key={this.state.template._id}>
                    <div className="d-flex justify-content-center">{apps}</div>
                    <br />
                    <table className="icons-list"><tbody><tr>
                        <td className="disabled">{template.title}
                            <br />
                            <br />
                            <Vote votes={template.votes} type="template" docId={template._id} /></td>
                    </tr></tbody></table>
                </div>)
        } else {
            return this.props.isLegacy? (

                <div className="p-4" onClick={this.onClick} style={{ border: "1px solid #E6E6E6", borderRadius: "10px", padding: "40px", margin: "20px", cursor: "pointer", width: "300px" }} key={template._id}>
                    <div className="d-flex justify-content-center">{apps}</div>
                    <br />
                    <table className="icons-list"><tbody>
                        <tr><td className="disabled">{template.title}</td>
                            {this.props.onDelete ?
                                <td className="icons-list-item"><button onClick={(event) => { event.stopPropagation(); event.preventDefault(); this.setState({ showDeleteConfirmation: true }); return false; }} className="btn btn-default icons-list-item"><i className="fa fa-trash"></i></button></td>
                                : <></>}
                        </tr></tbody></table>
                    {this.props.onDelete ?
                        <ConfirmationPopup show={this.state.showDeleteConfirmation}
                            title={t("warning")}
                            onConfirm={() => { this.setState({ showDeleteConfirmation: false }); this.props.onDelete(template._id); }}
                            onHide={() => this.setState({ showDeleteConfirmation: false })}
                            text={t("lbltemplatedeleteconfirm")}
                            buttonText={t("btndeleteconfirm")} />
                        : ""}
                </div>
            ) : (

                <div className="p-4" onClick={this.onClick} style={{ border: "1px solid #E6E6E6", borderRadius: "10px", padding: "40px", cursor: "pointer", width: "300px", margin: this.props.windowWidth > 993 ? "20px" : "auto" }} key={template._id}>
                    <div className="d-flex justify-content-center">{apps}</div>
                    <br />
                    <table className="icons-list"><tbody>
                        <tr><td className="disabled">{template.title}</td>
                            {this.props.onDelete ?
                                <td className="icons-list-item"><button onClick={(event) => { event.stopPropagation(); event.preventDefault(); this.setState({ showDeleteConfirmation: true }); return false; }} className="btn btn-default icons-list-item"><i className="fa fa-trash"></i></button></td>
                                : <></>}
                        </tr></tbody></table>
                    {this.props.onDelete ?
                        <ConfirmationPopup show={this.state.showDeleteConfirmation}
                            title={t("warning")}
                            onConfirm={() => { this.setState({ showDeleteConfirmation: false }); this.props.onDelete(template._id); }}
                            onHide={() => this.setState({ showDeleteConfirmation: false })}
                            text={t("lbltemplatedeleteconfirm")}
                            buttonText={t("btndeleteconfirm")} />
                        : ""}
                </div>
            )
        }


    }
}

export default withTranslation()(CustomListComponent)